import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const PartnersThunk = createAsyncThunk(
	'PartnersThunk`',
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get('https://api.act2hf.com/api/public/partners');

			return res?.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	},
);
